import { useState } from "react";
import { Save, KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminAccount() {
    const { user } = useAuth();
    const [current, setCurrent] = useState("");
    const [next1, setNext1] = useState("");
    const [next2, setNext2] = useState("");
    const [saving, setSaving] = useState(false);

    const save = async (e) => {
        e.preventDefault();
        if (next1.length < 6) return toast.error("A nova palavra-passe deve ter pelo menos 6 caracteres");
        if (next1 !== next2) return toast.error("As palavras-passe não coincidem");
        setSaving(true);
        try {
            await api.post("/auth/change-password", { current_password: current, new_password: next1 });
            toast.success("Palavra-passe alterada com sucesso!");
            setCurrent(""); setNext1(""); setNext2("");
        } catch (err) { toast.error(formatApiError(err)); }
        finally { setSaving(false); }
    };

    return (
        <div className="max-w-xl space-y-6" data-testid="admin-account">
            <div>
                <h1 className="font-heading text-3xl font-bold tracking-tight">A minha conta</h1>
                <p className="text-white/60">Sessão atual e alteração de palavra-passe.</p>
            </div>
            <div className="ab-card p-8">
                <div className="text-xs text-white/50 uppercase tracking-widest">Utilizador</div>
                <div className="text-lg font-heading font-bold mt-1">{user?.name}</div>
                <div className="text-white/60">{user?.email}</div>
            </div>
            <div className="ab-card p-8">
                <h2 className="font-heading font-bold text-lg mb-4 flex items-center gap-2"><KeyRound className="w-4 h-4" /> Alterar palavra-passe</h2>
                <form onSubmit={save} className="space-y-4">
                    <div>
                        <Label>Palavra-passe atual</Label>
                        <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="pwd-current" />
                    </div>
                    <div>
                        <Label>Nova palavra-passe</Label>
                        <Input type="password" value={next1} onChange={(e) => setNext1(e.target.value)} required data-testid="pwd-new" />
                    </div>
                    <div>
                        <Label>Confirmar nova palavra-passe</Label>
                        <Input type="password" value={next2} onChange={(e) => setNext2(e.target.value)} required data-testid="pwd-confirm" />
                    </div>
                    <Button type="submit" disabled={saving} className="ab-btn-primary rounded-full" data-testid="pwd-save">
                        {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />} Guardar
                    </Button>
                </form>
            </div>
        </div>
    );
}
